module.exports = __webpack_public_path__ + "img/9788971994337.1cb84b01.jpg";